import { Header as DarriusHeader } from 'darrius';

interface ILink {
  text: string;
  link: string;
}

export interface IHeaderContent {
  about?: ILink;
  signup?: ILink;
}

interface IHeaderDefault {
  header?: IHeaderContent;
  onlyLogo?: boolean;
}

function Default({ header, onlyLogo = false }: IHeaderDefault) {
  return (
    <DarriusHeader.Root
      onlyLogo={onlyLogo}
      logoLink={process.env.NEXT_PUBLIC_HOST}
    >
      <DarriusHeader.NavMenu>
        {header && header.signup && <DarriusHeader.Link {...header.signup} />}
        {header && header.about && <DarriusHeader.Link {...header.about} />}
      </DarriusHeader.NavMenu>
    </DarriusHeader.Root>
  );
}

function Simple() {
  return (
    <DarriusHeader.Root
      onlyLogo={true}
      logoLink={process.env.NEXT_PUBLIC_HOST}
    />
  );
}

export interface IUserProDataResponse {
  name: string | null;
  phone: string | null;
  avatar: string | null;
  isAuthenticated: boolean;
}

interface IHeaderAuth {
  profileData: IUserProDataResponse;
  header?: IHeaderContent;
  handleProfileSignOut: () => void;
}

function Auth({ header, profileData, handleProfileSignOut }: IHeaderAuth) {
  return (
    <DarriusHeader.Root logoLink={process.env.NEXT_PUBLIC_HOST}>
      <DarriusHeader.NavMenu>
        {header && (
          <>
            {header.signup && <DarriusHeader.Link {...header.signup} />}
            {header.about && <DarriusHeader.Link {...header.about} />}
          </>
        )}

        <DarriusHeader.Auth
          isLogged={profileData.isAuthenticated}
          onLogout={handleProfileSignOut}
          isLoading={false}
          user={{
            avatar: profileData?.avatar || '',
            name: profileData?.name || '',
            phone: profileData?.phone || '',
          }}
        />
      </DarriusHeader.NavMenu>
    </DarriusHeader.Root>
  );
}

export { Default, Simple, Auth };
